

import { BidiModule } from '@angular/cdk/bidi';
import { PlatformModule } from '@angular/cdk/platform';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MwcIconModule } from 'mwc/icon';

import { MwcAvatarGroupComponent } from './avatar-group.component';
import { MwcAvatarComponent } from './avatar.component';

@NgModule({
  declarations: [MwcAvatarComponent, MwcAvatarGroupComponent],
  exports: [MwcAvatarComponent, MwcAvatarGroupComponent],
  imports: [BidiModule, CommonModule, MwcIconModule, PlatformModule]
})
export class MwcAvatarModule {}
